import { Controller } from "@hotwired/stimulus"

// Filters My Tries cards by verb (do / say / remember / ask); "all" resets.
// Cards carry data-verb (empty for resources without a Try Prompt, so they
// only appear under "all"). cardTargetConnected keeps the active filter
// applied to cards re-rendered by turbo streams (complete/reactivate).
export default class extends Controller {
  static targets = ["button", "card", "emptyState"]
  static values = { current: { type: String, default: "all" } }

  filter(event) {
    this.currentValue = event.params.verb
  }

  currentValueChanged() {
    this.buttonTargets.forEach((button) => {
      const active = button.dataset.myTriesFilterVerbParam === this.currentValue
      button.classList.toggle("is-active", active)
      button.setAttribute("aria-pressed", active)
    })
    this.cardTargets.forEach((card) => this.#apply(card))
    this.#updateEmptyState()
  }

  cardTargetConnected(card) {
    this.#apply(card)
    this.#updateEmptyState()
  }

  cardTargetDisconnected() {
    this.#updateEmptyState()
  }

  #apply(card) {
    const show = this.currentValue === "all" || card.dataset.verb === this.currentValue
    card.classList.toggle("hidden", !show)
  }

  #updateEmptyState() {
    if (!this.hasEmptyStateTarget) return
    const anyVisible = this.cardTargets.some((c) => !c.classList.contains("hidden"))
    this.emptyStateTarget.classList.toggle("hidden", anyVisible)
  }
}
